import type { Action } from './types';

const modules = import.meta.glob<{ default: Action }>(['./*.ts', '!./types.ts', '!./registry.ts'], {
  eager: true,
});

export const actionRegistry: Record<string, Action> = {};

for (const mod of Object.values(modules)) {
  actionRegistry[mod.default.action] = mod.default;
}
